import { createCampaignBriefsState } from "../types/campaign-briefs.functions";

import { CampaignBriefsActions, CampaignBriefsActionType } from "./campaign-briefs.actions";
import { LOADING_STATES } from "../../../features/loading";

export function campaignBriefsReducer(
  state = createCampaignBriefsState(),
  action: CampaignBriefsActionType
) {
  switch (action.type) {
    case CampaignBriefsActions.ChangePage:
      return {
        ...state,
        loading: { ...LOADING_STATES.loading },
        errors: null,
      };

    case CampaignBriefsActions.Fetch:
      return {
        ...state,
        loading: { ...LOADING_STATES.loading },
        errors: null,
        count: 0,
        results: [],
        prev: null,
        next: null,
      };

    case CampaignBriefsActions.FetchFailure:
      return {
        ...state,
        loading: { ...LOADING_STATES.failed },
        errors: action.payload,
        count: 0,
        results: [],
        prev: null,
        next: null,
      };

    case CampaignBriefsActions.FetchSuccess:
      return {
        ...state,
        loading: { ...LOADING_STATES.loaded },
        errors: null,
        ...action.payload,
      };

    case CampaignBriefsActions.FetchFiltersSuccess:
      return {
        ...state,
        filters: action.payload,
      };

    default:
      return state;
  }
}
